export enum EMIMETypes {
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  PDF = 'application/pdf',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  MS_CSV = 'application/vnd.ms-excel',
  CSV = 'text/csv',
}

export enum EMIMETypesLabel {
  JPG = 'JPG',
  PNG = 'PNG',
  PDF = 'PDF',
}
